import React from 'react'
import { Typography, Container, Grid } from '@mui/material'

interface HeadlineProps {
  title: string
}

const Headline: React.FC<HeadlineProps> = ({ title }) => {
  return (
    <Container maxWidth={'xl'}>
      <Grid container columns={12}>
        <Grid
          item
          xs={12}
          marginTop={{ md: 8, xs: 6 }}
          marginBottom={{ md: 6, xs: 2 }}>
          <Typography variant="h1" component="h1" gutterBottom>
            {title}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Headline
